import { Facebook, Instagram, Twitter, WhatsApp } from "@mui/icons-material";
import "./footer.css";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <div className="footer-page">
      <footer className="footer-container">
        <div className="footer-content">
          <div className="footer-section about">
            <h3>About Us</h3>
            <p className="p-2">
              Welcome to [Your Hotel/Restaurant Name], where comfort meets
              culinary delight. Enjoy a luxurious stay and savor exquisite
              dishes crafted by our chefs.
            </p>
            <ul className="d-flex justify-content-center social-icon-link">
              <li className="p-3">
                <Facebook style={{ color: "#175c90" }} fontSize="large" />
              </li>
              <li className="p-3">
                <Instagram style={{ color: "#a84026" }} fontSize="large" />
              </li>
              <li className="p-3">
                <WhatsApp style={{ color: "#549014" }} fontSize="large" />
              </li>
              <li className="p-3">
                <Twitter style={{ color: "#2486d2" }} fontSize="large" />
              </li>
            </ul>
          </div>
          <div className="footer-section contact">
            <h3>Contact Us</h3>
            <div>
              <strong>Address:</strong> 123 Main Street, Your City
            </div>
            <div>
              <strong>Phone:</strong> +123 456 7890
            </div>
            <div>
              <strong>Email:</strong> contact@yourdomain.com
            </div>
            <div>
              Hotel Location On Map
              <div>
                <iframe
                  title="hotelMap"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5866079.626870962!2d71.99461461509819!3d28.604751200000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce2c3d83ea011%3A0x719a5e5196b12ee8!2sTaj%20Mahal%2C%20New%20Delhi!5e1!3m2!1sen!2sin!4v1738259200432!5m2!1sen!2sin"
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="footer-section links">
            <h3>Quick Links</h3>
            <div>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/rooms">Rooms</Link>
                </li>
                <li>
                  <Link to="/gallery">Gallery</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; 2025 [Your Hotel/Restaurant Name]. All Rights Reserved.
            Website by{" "}
            <a href="https://mdfaizanahmad-dev.web.app/">Md Faizan Ahmad</a>
          </p>
        </div>
      </footer>
    </div>
  );
};
